export enum Codeowners {
  CUSTOMER_INTAKE = 'customer_intake',
  INNOVATION = 'innovation',
  JOB_INBOX = 'job_inbox',
  JOBS_2 = 'jobs_2',
}
